import { ReactNode } from 'react';
import { IconPendoInfo } from 'components/Icons';
import {
  IllustrationTipSwipeSelect,
  IllustrationTipBulkActions,
  IllustrationTipQuickActions,
  IllustrationTipPullToRefresh,
  IllustrationTipDragToFilter,
  IllustrationTipUnassigned,
  IllustrationTipBlockers,
} from 'components/Illustrations';

export interface TipItem {
  title: string;
  description: string;
  illustration: ReactNode;
}

export const defaultTips: TipItem[] = [
  {
    title: 'QUICK ACTIONS',
    description: 'Swipe a card left to reveal quick actions: More options, Resolve (or Block), and Assign.',
    illustration: <IllustrationTipQuickActions />,
  },
  {
    title: 'SELECT MULTIPLE',
    description: 'You can add / remove requests to your selection by swiping the request cards right.',
    illustration: <IllustrationTipSwipeSelect />,
  },
  {
    title: 'BULK ACTIONS',
    description: 'When you have cards selected, bulk action options appear at the top of the list.',
    illustration: <IllustrationTipBulkActions />,
  },
  {
    title: 'DRAG TO FILTER',
    description: 'Long press on a selected card to drag it to any filter pill at the top.',
    illustration: <IllustrationTipDragToFilter />,
  },
  {
    title: 'PULL TO REFRESH',
    description: 'Pull down on the list to refresh and get the latest updates.',
    illustration: <IllustrationTipPullToRefresh />,
  },
  {
    title: 'UNASSIGNED REQUESTS',
    description: "A dashed circle around an avatar means the request hasn't been assigned yet.",
    illustration: <IllustrationTipUnassigned />,
  },
  {
    title: 'ATTENTION: BLOCKERS',
    description: 'When the Blockers pill is pulsing, there are urgent items that need your attention.',
    illustration: <IllustrationTipBlockers />,
  },
];
